import { render, staticRenderFns } from "./completee-artisan.vue?vue&type=template&id=d35d7cd4"
import script from "./completee-artisan.vue?vue&type=script&lang=ts"
export * from "./completee-artisan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports